// extracted by mini-css-extract-plugin
var _1 = "AnnotationLink-module__animateUploadProgressBarWidth--UdC0Y";
var _2 = "AnnotationLink-module__animatedBackground--Xhr2r";
var _3 = "AnnotationLink-module__container--hmebr";
var _4 = "AnnotationLink-module__icon--ou1RY";
var _5 = "AnnotationLink-module__link--w9ZkS";
var _6 = "AnnotationLink-module__linkText--pu6xI";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "container", _4 as "icon", _5 as "link", _6 as "linkText" }
